export const ENQUEUE_SNACKBAR = 'snackbar/ENQUEUE_SNACKBAR'
export const CLOSE_SNACKBAR = 'snackbar/CLOSE_SNACKBAR'
export const REMOVE_SNACKBAR = 'snackbar/REMOVE_SNACKBAR'
